

















import { Component, Vue } from "vue-property-decorator";
import { getConfigData, svipInfo } from "@/service/api";
import { namespace } from "vuex-class";

const loginModule = namespace("login");

@Component
export default class App extends Vue {
    @loginModule.State((state) => state.token)
    token!: string;
    tToken = (localStorage.getItem("tToken"));
    async created() {
        let data = {
            key: "h5_yqw_wechat_pay",
        };
        let res: any = await getConfigData(data);
        console.log(`res`, res && JSON.stringify(res, null, "\t"));

        if (res && res.status) {
            localStorage.setItem("payChannelObj", res.status);
        }
        setTimeout(async () => {
            if (this.token || this.tToken) {
                await this.getsvipInfo();
            }
        }, 500);
    }
    async getsvipInfo() {
        let res = await svipInfo();
        if (res) {
            this.$store.commit("login/UPDATE_SVIPINFO", res);
        }
    }
}
